import { useQuery } from '@tanstack/react-query';

import { useSnackbar } from '@/features/snackbar';

import { queryFn, getQueryKey } from './queryFn';
import { useEffect } from 'react';

type Args = {
  providerName: string;
  onSuccess?(d: Awaited<ReturnType<typeof queryFn>>): void;
  onError?(): void;
};

export function useGeneratePortfolioLinkAccessToken({
  providerName,
  onError,
  onSuccess,
}: Args) {
  const { addSnackbar } = useSnackbar();
  const query = useQuery({
    queryKey: getQueryKey(providerName),
    queryFn,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });

  const { data, status } = query;

  useEffect(() => {
    if (status === 'success') {
      onSuccess?.(data);
    }
  }, [data, status, onSuccess]);

  useEffect(() => {
    if (status === 'error') {
      onError?.();
      addSnackbar({
        type: 'negative',
        message: 'Failed to connect',
        lifeTime: 2000,
      });
    }
  }, [status, onError, addSnackbar]);

  return query;
}
